import { RefObject, useEffect } from 'react'

/**
 * Act on clicks outside of a referenced container. Use with
 * functional components
 *
 * Used by NotificationContainer.
 *
 *    // initiate
 *     const ref = useRef<HTMLDivElement>(null)
 *     useClickOutside(ref, ()=>{
 *        // call a function that closes the panel
 *       }
 *     );
 *
 *    // add ref to the primary div
 *    <div ref={ref} className="notifications-container">
 *
 *    // in the parent component, wrap the notification so that
 *    // the click that opens the panel does not immediately close
 *    // the panel
 *    {someboolean && <ComponentUsingUseClickOutside /> }
 *
 *
 * @param ref
 * @param callback
 * @param addEventListener
 */
export const useClickOutside = (
  ref: RefObject<HTMLElement | undefined>,
  callback: () => void,
  addEventListener = true,
) => {
  const handleClick = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
      callback();
    }
  }

  useEffect(() => {
    if (addEventListener) {
      document.addEventListener('click', handleClick);
    }

    return () => {
      document.removeEventListener('click', handleClick);
    }
  })
}